import React, {memo} from 'react';

interface EnvelopeStampProps {
  imageUrl?: string | null;
}

export const EnvelopeStamp: React.FC<EnvelopeStampProps> = memo(({imageUrl}) => {
  if (!imageUrl) return null;

  return <img className="envelope_image__wrapper__stamp" src={imageUrl} alt="Stamp" />;
});
